module.exports = __webpack_public_path__ + "static/media/Icono estampas.d258d16e.svg";